import Button from "../../components/Shared/Button"
import AddIcon from "../../components/Icons/AddIcon"
import { useState } from "react"
import { useQuery } from "@tanstack/react-query"
import { GetAllConsultants } from "../../api/Consultation/GetAllConsultants"
import ConsultantCard from "../../components/Consultancies/ConsultantCard"
import AddNewConsultant from "../../components/Consultancies/AddNewConsultant"
import Spinner from "../../components/Shared/Spinner"
const Consultants = () => {
    const [showAddMember, setShowAddMember] = useState(false);
    const { data: Consultants, isLoading } = useQuery({
        queryFn: GetAllConsultants,
        queryKey: ["consultants"],
        staleTime: 0,
        refetchInterval: 0,
    });
    const consultants = Consultants?.data;
    const handleAddMemberSuccess = () => {
        setShowAddMember(false);
    };

    return (
        <div>
            {showAddMember ? (
                <AddNewConsultant onSuccess={handleAddMemberSuccess} />
            ) : (

                <div>
                    <div className="flex justify-between items-center py-7">
                        <h1 className="text-burntBlack font-bold text-[32px]">Consultants</h1>
                        <Button
                            onClick={() => setShowAddMember(true)}
                            className="!h-12 w-52 !text-sm font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
                            variant="primary"
                        >
                            <AddIcon className="mr-1.5" />
                            Add New Consultant
                        </Button>
                    </div>
                    {isLoading ? (<div className="h-[50vh] flex items-center justify-center">
                        <Spinner />
                    </div>) : (<div className="grid grid-cols-4 gap-7">
                        {consultants?.map((Team) => (
                            <ConsultantCard consultantId={Team.id} img={Team.img_url} title={Team.title} name={Team.name} />
                        ))}
                    </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default Consultants